const BanzaButtonPresets = {
  BanzaButton: {
    class: "banza-btn rounded-lg",
    attrs: {
      variant: "text",
      color: "primary"
    },
    presets: {
      icon: {
        attrs: {
          variant: "outlined"
        }
      },
      orange: {
        class: "orange",
        attrs: {
          color: "black"
        }
      },
      purple: {
        class: "purple",
        attrs: {}
      },
      flat: {
        class: "text-white",
        attrs: {
          variant: "flat",
          color: "primary"
        }
      },
      back: {
        class: "px-0 rounded-lg",
        isClassOverride: true,
        attrs: {
          "variant": "text",
          "color": "primary",
          "min-width": 24
        },
        slots: {
          icon: {
            attrs: {
              icon: "mdi-arrow-left",
              size: 24
            }
          }
        }
      },
      closeMini: {
        class: "px-0 rounded-lg",
        isClassOverride: true,
        attrs: {
          "variant": "text",
          "color": "primary",
          "min-width": 24
        },
        slots: {
          icon: {
            attrs: {
              icon: "mdi-close",
              size: 24
            }
          }
        }
      },
      closeIcon: {
        preset: "BanzaButton.icon",
        attrs: {
          size: 24
        },
        slots: {
          icon: {
            attrs: {
              icon: "mdi-close",
              size: 18
            }
          }
        }
      },
      moduleEdit: {
        preset: "BanzaButton.icon",
        slots: {
          icon: {
            attrs: {
              icon: "lets-icons:edit-duotone"
            }
          }
        }
      },
      saveMini: {
        preset: "BanzaButton.icon",
        slots: {
          icon: {
            attrs: {
              icon: "fluent:save-20-filled"
            }
          }
        }
      },
      moduleReload: {
        preset: "BanzaButton.icon",
        slots: {
          icon: {
            attrs: {
              icon: "lets-icons:refresh-2-light"
            }
          }
        }
      },
      cancel: {
        attrs: {
          textLcz: "base.buttons.cancel"
        },
        slots: {
          icon: {
            attrs: {
              icon: "lets-icons:refund-back-light"
            }
          }
        }
      },
      save: {
        class: "text-white",
        attrs: {
          variant: "flat",
          color: "primary",
          textLcz: "base.buttons.save"
        },
        slots: {
          icon: {
            attrs: {
              icon: "fluent:save-20-filled"
            }
          }
        }
      },
      delete: {
        preset: "BanzaButton.orange",
        attrs: {
          textLcz: "base.buttons.delete"
        },
        slots: {
          icon: {
            attrs: {
              icon: "lets-icons:trash-duotone",
              color: "#474554"
            }
          }
        }
      },
      close: {
        attrs: {
          variant: "text",
          color: "primary",
          textLcz: "base.buttons.close"
        }
      },
      filterLoading: {
        preset: "BanzaButton.icon",
        class: " spin",
        slots: {
          icon: {
            attrs: {
              icon: "lets-icons:compass-duotone-line",
              color: "#f1f1f1"
            }
          }
        },
        attrs: {
          variant: "flat"
        }
      },
      filterAdd: {
        preset: "BanzaButton.icon",
        class: "",
        slots: {
          icon: {
            attrs: {
              icon: "lets-icons:filter-alt-duotone-line",
              color: "#f1f1f1"
            }
          }
        },
        attrs: {
          variant: "flat"
        }
      },
      filterSelected: {
        preset: "BanzaButton.icon",
        class: "orange",
        slots: {
          icon: {
            attrs: {
              icon: "lets-icons:setting-line-duotone-line",
              color: "#474554"
            }
          }
        },
        attrs: {
          color: "#ffefd1",
          variant: "flat"
        }
      },
      hiddenColumns: {
        attrs: {
          textLcz: "base.buttons.hidden_columns"
        },
        slots: {
          icon: {
            attrs: {
              icon: "lets-icons:eye-duotone"
            }
          }
        }
      },
      hiddenColumns2: {
        preset: "BanzaButton.icon",
        attrs: {},
        slots: {
          icon: {
            attrs: {
              icon: "lets-icons:eye-duotone"
            }
          }
        }
      },
      exportTo: {
        attrs: {
          textLcz: "base.buttons.export_to"
        },
        slots: {
          icon: {
            attrs: {
              icon: "lets-icons:download-duotone",
              right: true
            }
          }
        }
      },
      add: {
        class: "",
        slots: {
          icon: {
            attrs: {
              icon: "lets-icons:add-square-duotone"
            }
          }
        },
        attrs: {
          variant: "text",
          textLcz: "base.buttons.add"
        }
      },
      publish: {
        class: "text-white",
        attrs: {
          variant: "flat",
          color: "primary",
          textLcz: "base.buttons.publish"
        },
        slots: {
          icon: {
            attrs: {
              right: true,
              icon: "lets-icons:send-fill"
            }
          }
        }
      },
      generateCode: {
        preset: "BanzaButton.orange",
        attrs: {
          textLcz: "base.buttons.generate_code"
        },
        slots: {
          icon: {
            attrs: {
              class: "mr-1",
              icon: "lets-icons:refresh-2-light"
            }
          }
        }
      },
      contentEdit: {
        attrs: {
          textLcz: "components.admin.notification_template_edit.open_editor"
        },
        slots: {
          icon: {
            attrs: {
              icon: "lets-icons:edit-duotone"
            }
          }
        }
      },
      copy: {
        attrs: {
          textLcz: "base.buttons.copy"
        },
        slots: {
          icon: {
            attrs: {
              icon: "lets-icons:copy-light"
            }
          }
        }
      },
      screenshot: {
        attrs: {
          textLcz: "base.buttons.screenshot"
        },
        slots: {
          icon: {
            attrs: {
              icon: "lets-icons:camera-duotone-line",
              right: true
            }
          }
        }
      },
      view: {
        attrs: {
          textLcz: "base.buttons.view"
        },
        slots: {
          icon: {
            attrs: {
              icon: "lets-icons:eye-duotone"
            }
          }
        }
      },
      showHistory: {
        attrs: {
          textLcz: "base.buttons.show_changes_history"
        },
        slots: {
          icon: {
            attrs: {
              icon: "mdi-history"
            }
          }
        }
      },
      goBack: {
        preset: "BanzaButton.orange",
        attrs: {
          textLcz: "base.buttons.goBack"
        },
        slots: {
          icon: {
            attrs: {
              icon: "lets-icons:arrow-left-light"
            }
          }
        }
      },
      favoriteAdd: {
        attrs: {
          textLcz: "base.buttons.favorites"
        },
        slots: {
          icon: {
            attrs: {
              icon: "solar:star-linear"
            }
          }
        }
      },
      favoriteSelected: {
        class: "orange",
        attrs: {
          color: "black",
          textLcz: "base.buttons.favorites"
        },
        slots: {
          icon: {
            attrs: {
              icon: "solar:star-bold",
              color: "#474554"
            }
          }
        }
      },
      upload: {
        attrs: {
          textLcz: "base.buttons.load"
        },
        slots: {
          icon: {
            attrs: {
              icon: "lets-icons:upload-duotone",
              color: "primary"
            }
          }
        }
      }
    }
  }
};
export {
  BanzaButtonPresets as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
